/**
 * Mobile (≤989px): menú arriba izq., carrito abajo izq. 8px; ocultar al bajar scroll.
 */
(function () {
  var MOBILE_MQ = '(max-width: 989px)';
  var SCROLL_HIDE_AT = 24;
  var SCROLL_DELTA = 2;
  var mql = window.matchMedia(MOBILE_MQ);
  var lastScrollTop = 0;
  var lenisBound = false;
  var pollId = null;
  var menuOverlayHiding = false;

  function isMobile() {
    return mql.matches;
  }

  function getScrollTop() {
    var lenis = window.lenis1925;
    if (lenis && typeof lenis.scroll === 'number' && !isNaN(lenis.scroll)) {
      return lenis.scroll;
    }
    return (
      window.scrollY ||
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
    );
  }

  function isMenuOpen() {
    var overlay = document.getElementById('header-1925-menu-overlay');
    return overlay && overlay.classList.contains('is-open');
  }

  function getFloatingControls() {
    return document.querySelectorAll(
      '[data-header-1925-floating-menu], [data-header-1925-floating-cart]:not(.header-1925-floating-cart--hidden)'
    );
  }

  function mountFloatingControls() {
    if (!isMobile()) return;
    getFloatingControls().forEach(function (control) {
      if (control.parentNode !== document.body) {
        document.body.appendChild(control);
      }
      if (control.matches('[data-header-1925-floating-menu]')) {
        control.style.setProperty('top', '8px', 'important');
        control.style.setProperty('left', '8px', 'important');
        control.style.setProperty('right', 'auto', 'important');
        control.style.setProperty('bottom', 'auto', 'important');
      } else {
        control.style.setProperty('bottom', '8px', 'important');
        control.style.setProperty('left', '8px', 'important');
        control.style.setProperty('right', 'auto', 'important');
        control.style.setProperty('top', 'auto', 'important');
      }
      control.style.setProperty('position', 'fixed', 'important');
      if (!menuOverlayHiding && !control.classList.contains('header-1925-floating-trigger--scroll-hidden')) {
        control.style.setProperty('z-index', '1201', 'important');
      }
    });
  }

  function clearInlineHideStyles(control) {
    control.style.removeProperty('display');
    control.style.removeProperty('visibility');
    control.style.removeProperty('pointer-events');
    control.style.removeProperty('opacity');
    control.style.removeProperty('z-index');
  }

  function setControlsUnderMenuOverlay(under) {
    menuOverlayHiding = under;
    getFloatingControls().forEach(function (control) {
      control.classList.toggle('header-1925-floating-trigger--menu-overlay-hidden', under);
      if (under) {
        control.setAttribute('aria-hidden', 'true');
        control.style.setProperty('display', 'none', 'important');
        control.style.setProperty('visibility', 'hidden', 'important');
        control.style.setProperty('pointer-events', 'none', 'important');
        control.style.setProperty('opacity', '0', 'important');
        control.style.setProperty('z-index', '1', 'important');
      } else {
        control.removeAttribute('aria-hidden');
        if (!control.classList.contains('header-1925-floating-trigger--scroll-hidden')) {
          clearInlineHideStyles(control);
          control.style.setProperty('z-index', '1201', 'important');
        }
      }
    });
  }

  function setControlsScrollHidden(hidden) {
    getFloatingControls().forEach(function (control) {
      if (menuOverlayHiding) return;
      control.classList.toggle('header-1925-floating-trigger--scroll-hidden', hidden);
      if (hidden) {
        control.setAttribute('aria-hidden', 'true');
        control.style.setProperty('pointer-events', 'none', 'important');
      } else {
        control.removeAttribute('aria-hidden');
        control.removeAttribute('hidden');
        clearInlineHideStyles(control);
        control.style.setProperty('z-index', '1201', 'important');
      }
    });
  }

  function updateFloatingControlsOnScroll() {
    mountFloatingControls();

    if (!isMobile()) {
      setControlsUnderMenuOverlay(false);
      setControlsScrollHidden(false);
      lastScrollTop = getScrollTop();
      return;
    }

    if (isMenuOpen()) {
      setControlsUnderMenuOverlay(true);
      lastScrollTop = getScrollTop();
      return;
    }

    setControlsUnderMenuOverlay(false);

    var scrollTop = getScrollTop();

    if (scrollTop <= SCROLL_HIDE_AT) {
      setControlsScrollHidden(false);
    } else if (scrollTop > lastScrollTop + SCROLL_DELTA) {
      setControlsScrollHidden(true);
    } else if (scrollTop < lastScrollTop - SCROLL_DELTA) {
      setControlsScrollHidden(false);
    }

    lastScrollTop = scrollTop;
  }

  window.header1925Floating = {
    setUnderMenuOverlay: setControlsUnderMenuOverlay,
    refresh: updateFloatingControlsOnScroll,
  };

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      updateFloatingControlsOnScroll();
      ticking = false;
    });
  }

  function bindLenis() {
    var lenis = window.lenis1925;
    if (!lenis || lenisBound) return;
    lenisBound = true;
    if (typeof lenis.on === 'function') {
      lenis.on('scroll', onScroll);
    }
  }

  function startLenisWatch() {
    if (lenisBound) return;
    bindLenis();
    if (!lenisBound) {
      pollId = window.setInterval(function () {
        bindLenis();
        onScroll();
        if (lenisBound && pollId) {
          window.clearInterval(pollId);
          pollId = null;
        }
      }, 150);
      window.setTimeout(function () {
        if (pollId) {
          window.clearInterval(pollId);
          pollId = null;
        }
      }, 12000);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true, capture: true });
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', onScroll, { passive: true });
  window.addEventListener('touchmove', onScroll, { passive: true });
  window.addEventListener('wheel', onScroll, { passive: true });

  if (typeof mql.addEventListener === 'function') {
    mql.addEventListener('change', onScroll);
  } else if (typeof mql.addListener === 'function') {
    mql.addListener(onScroll);
  }

  function init() {
    mountFloatingControls();
    startLenisWatch();
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', init);
})();
